import Swal from 'sweetalert2';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SwalAlertHelper {

    constructor() {

    }
    swalEventoExitoso(informacionSwal): void {

        Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: informacionSwal.mensajeSwal || 'Accion realizada con exito',
            showConfirmButton: false,
            showCloseButton: true,
            backdrop: `none`,
            timer: 20000,
            timerProgressBar: true,
            background: '#CEF6CE',
        });
    }

    swalEventoWarning(informacionSwal, config = null): void {
        Swal.fire({
            position: 'top-end',
            icon: 'warning',
            title: informacionSwal.mensajeSwal,
            showConfirmButton: (config == null ? false: ( config.showConfirmButton ? true:false)),
            confirmButtonText: (config == null ? '': config.mensaje),
            showCloseButton: true,
            backdrop: `none`,
            timer: 20000,
            timerProgressBar: true,
            background: '#CEF6CE',
        });
    }

    swalEventoUrgente(informacionSwal, config = null): any {

        return Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: informacionSwal.mensajeSwal,
            confirmButtonText: config.mensaje,
            showConfirmButton: config.showConfirmButton ? true:false,
            showCloseButton: true,
            backdrop: `none`,
            timer: 30000,
            timerProgressBar: true,
            color: '#ffffff',
            background: '#e30000',
        });
    }

    swalEventoInfo(informacionSwal, config = null): any {
        return Swal.fire({
            position: 'top-end',
            icon: 'info',
            title: informacionSwal.mensajeSwal,
            showConfirmButton: config.showConfirmButton ? true:false,
            confirmButtonText: config.mensaje,
            showCloseButton: true,
            backdrop: `none`,
            timer: 20000,
            timerProgressBar: true,
            background: '#CEF6CE',
        });
    }
    

    Eliminar(informacion): any {
        return Swal.fire({
            title: informacion.titulo,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, Eliminar!',
            cancelButtonText: 'No, Eliminar!',
            reverseButtons: true,
            confirmButtonColor: '#d33'
        });
    }

    confirmarEliminar(informacion): any {
        return Swal.fire({
            title: informacion.titulo,
            text: 'Indique el motivo.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, confirmo!',
            cancelButtonText: 'No, cancelar!',

            input: 'textarea',
            inputAttributes: {
                autocapitalize: 'off',
            },
            preConfirm: (pComentario) => {
                if (String(pComentario) === '') {
                    Swal.showValidationMessage(
                        'Debe ingresar un motivo'
                    );
                }
                else {
                    return pComentario;
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        });
    }


    Confirmar(informacion): any {
        return Swal.fire({
            title: informacion.titulo,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: '¡Si, continuar!',
            cancelButtonText: '¡No, continuar!',
            reverseButtons: true,
        });
    }

    mostrarInformacionExistosa(informacion): any {
        return Swal.fire({
            title: informacion.titulo,
            showCancelButton: true,
            icon: "success",
            html: informacion.texto
        });
    }

    swalToastEventoFallido(informacionSwal): void {

        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: informacionSwal.valorTimer || 10000,
            timerProgressBar: true,
            padding: 15,

        });

        Toast.fire({
            icon: 'error',
            title: informacionSwal.titulo,
            html: informacionSwal.mensajeSwal || 'Accion realizada con exito'
        });

    }
}
